<template>
    <v-card min-width="25vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #d2d7e1">
            <v-list-item>
                <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-5 pt-5">
            <v-form v-model="valid">
                <v-container fluid>
                    <v-row class="mb-n4 mt-n2">
                        <v-col>
                            <v-text-field :label="$t('items.firstName')" v-model="firstName" :rules="firstNameRule" outlined/>
                        </v-col>
                        <v-col>
                            <v-text-field :label="$t('items.lastName')" v-model="lastName" :rules="lastNameRule" outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field :label="$t('items.username')" :hint="$t('items.usernameHint')" v-model="username" :rules="usernameRule" outlined/>
                        </v-col>
                        <v-col>
                            <v-text-field :label="$t('items.phoneNumber')" v-model="phoneNumber" :rules="phoneNumberRule" outlined/>
                        </v-col>
                    </v-row>
                    <v-textarea :label="$t('items.description')" :placeholder="$t('items.descriptionPlaceholder')"
                                :hint="$t('items.descriptionHint')" v-model="profileDescription" rows="1"
                                :rules="descriptionRule"
                                counter auto-grow outlined/>
                    <div class="mb-3 mt-2">
                        <v-btn @click="closeWindow">{{ $t('btnCancel') }}</v-btn>
                        <v-btn class="ml-5" @click="editProfile">{{ $t('btnSave') }}</v-btn>
                    </div>
                </v-container>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
    import Repository from '../../../repositories/auth';
    import { mapMutations } from 'vuex';

    export default {
        name: "EditProfile",
        data() {
            return {
                firstName: '',
                lastName: '',
                username: '',
                phoneNumber: '',
                profileDescription: '',

                // Rules
                valid: false,
                firstNameRule: [
                    p => !!p || 'First Name is required',
                ],
                lastNameRule: [
                    p => !!p || 'Last Name is required',
                ],
                usernameRule: [
                    u => !!u || 'Username is required',
                    u => (u || '' ).length < 35 || 'Username should have less than 35 characters.',
                    u => !u.includes('@') || 'Not \'@\' allowed',
                    u => (u.split(' ').length <= 1) || 'Not spaces allowed',
                ],
                phoneNumberRule: [
                    p => !!p || 'Phone number is required',
                    p => (p || '' ).length < 28 || 'Phone number should have less than 28 characters.',
                ],
                descriptionRule: [
                    d => !!d || 'Description is required',
                    d => (d && d.length <= 77) || 'Max 77 characters',
                ],
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.firstName = this.$store.state.user.firstName;
                this.lastName = this.$store.state.user.lastName;
                this.username = this.$store.state.user.username;
                this.phoneNumber = this.$store.state.user.details.phoneNumber;
                this.profileDescription = this.$store.state.user.details.profileDescription;
            },
            editProfile() {
                if (this.valid) {
                    if(this.username === this.$store.state.user.username)
                        this.tryEditing();
                    else
                        Repository.existingUsernameOrEmail(this.username, 'email@email.com').then((response) => {
                            if(response.status < 400) {
                                let data = response.data;
                                if(data !== 2) {
                                    this.tryEditing();
                                }
                                else
                                    alert('The username already exists in Swiset.\nPlease choose another one.');
                            }
                        });
                } else
                    alert('There are one or more mandatory fields that are not filled.');
            },
            ...mapMutations(['setNewProfile']),
            tryEditing() {
                let newProfileData = {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    username: this.username,
                    phoneNumber: this.phoneNumber,
                    profileDescription: this.profileDescription,
                    referredFrom: this.$store.state.user.details.referredFrom,
                };

                Repository.editProfile(newProfileData).then((response) => {
                    if(response.status < 400 && response.data) {
                        this.setNewProfile(newProfileData);
                        this.closeWindow();
                    }
                });
                this.closeWindow();
            },
            closeWindow() {
                this.$emit('closeWindow');
            },
        }
    }
</script>

<i18n>
{
  "en": {
    "title": "Edit Profile",
    "items": {
      "firstName": "First Name",
      "lastName": "Last Name",
      "username": "Username",
      "usernameHint": "Unique username",
      "phoneNumber": "Phone Number",
      "description": "Profile Description",
      "descriptionHint": "Short description of you",
      "descriptionPlaceholder": "Day trader of #SP500 and #NASDAQ"
    },
    "btnCancel": "Cancel",
    "btnSave": "Save and Close"
  },
  "es": {
    "title": "Editar Profile",
    "items": {
      "firstName": "Nombres",
      "lastName": "Apellidos",
      "username": "Usuario",
      "usernameHint": "Usuario Único",
      "phoneNumber": "Celular",
      "description": "Descripción del Perfil",
      "descriptionHint": "Corta descripción tuya",
      "descriptionPlaceholder": "Day trader del #SP500 y #NASDAQ"
    },
    "btnCancel": "Cancelar",
    "btnSave": "Guardar y Cerrar"
  }
}
</i18n>

<style scoped>

</style>
